import { PHARM_CLASSES } from "@/lib/pharmacologyKnowledgeBase";

const EXTRA_CLASSES = [
  "Agonista dopaminérgico D2/D3 não ergot",
];

export function ensureClinicalClassOptions() {
  for (const pharmacologicalClass of EXTRA_CLASSES) {
    if (!PHARM_CLASSES.includes(pharmacologicalClass)) {
      PHARM_CLASSES.unshift(pharmacologicalClass);
    }
  }
}